/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";

import { useDebouncedCallback } from "use-debounce";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";

import { InputNumberFormat } from "@react-input/number-format";

import { Download, Trash2 } from "react-feather";
import Spinner from "../Spinner";
import { formatearFecha, validateEmail } from "../CandidatosNP/utils";
import { AsyncLabSelect } from "../AsyncLabSelect";
import { getCandidatosByNP, getProveedoresMedicalStudies } from "../../services/candidatosNPServices";
import { StylesDatePicker } from "../../ui/stylesDatePicker";

import { BlurSpinner } from "../BlurSpinner";
import { TemplateHeader, Container, CustomLabel } from "../RelevosInfoGeneral/styles";
import { InputText, InputTextArea } from "../../ui/inputs";
import { LabSelect } from "../course/select";
import { configDatePickerLenguage, getPiById } from "../RelevosInfoGeneral/utils";
import { fetchCompanias } from "../../services/companiaServices";
import { handleErrors } from "../../services/handleErrors";
import useFetcher from "../../hooks/useFetcher";
import { fetchSucursales } from "../../services/sucursalServices";
import { fetchNotaDePedidoById } from "../../services/notasDePedidoServices";
import { ButtonPrimary, ModalButton, SpinnerButtonPrimary } from "../../ui/buttons";
import { GridGroup3, InputFile, InputNumberFormatWrapper } from "./styles";
import { downloadFile, patchFile, removeFile, uploadFiles } from "../../services/fileServices";
import { getSucursalTitleById } from "../../pages/NotasDePedido/utils";
import { createOrdenDeVenta, updateOrdenDeVenta } from "../../services/ordenDeVentaServices";
import { fetchPiAsignable } from "../../services/ticketingServices";
import { calcularTotal, formatNumberWithCommas, isFieldRequired } from "./utils";

const promiseOptions = (inputValue) =>
  new Promise((resolve) => {
    setTimeout(async () => {
      const params = {
        vendor: inputValue,
      };

      try {
        const response = await getProveedoresMedicalStudies(params);
        const proveedores = response.result;
        const { proveedoresNP } = proveedores || {};

        const options =
          proveedoresNP && proveedoresNP.length > 0
            ? proveedoresNP.map((proveedor) => ({
                label: proveedor.vendor,
                value: proveedor.id,
              }))
            : [];

        resolve(options);
      } catch (error) {
        resolve([]);
      }
    }, 500);
  });

export const createOrUpdateOrdenDeVenta = async (data, id) => {
  if (id) {
    const res = await updateOrdenDeVenta(id, data);
    return res;
  }
  const res = await createOrdenDeVenta(data);
  return res;
};

export const uploadOrPatchFileSoporteCliente = async (id, files, fileId) => {
  let response;
  if (fileId && fileId !== undefined) {
    response = await patchFile({ entity: "npOrdenDeVenta", entityId: id, fileId, files });
  } else {
    response = await uploadFiles({ entity: "npOrdenDeVenta", entityId: id, files });
  }
  return response;
};

export default function OrdenDeVentaForm({ toggle, orden, toggleTab, notaDePedidoId, canEditOV }) {
  const [notaFetched, isLoadingNota] = useFetcher(fetchNotaDePedidoById, [notaDePedidoId, {}]);
  const [nota, setNota] = useState(null);
  const readOnly = !canEditOV || (orden && orden.estado !== 1);

  const locale = configDatePickerLenguage();
  const fechaActual = moment().format("YYYY-MM-DD");
  const ordenId = orden && orden.idOrdenDeVenta;
  const [data, setData] = useState({});
  const [pis, isLoadingPis] = useFetcher(fetchPiAsignable, undefined, "fetchPiAsignable");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [sucursales, isLoadingSucursales] = useFetcher(fetchSucursales, undefined, "fetchSucursales");
  const [companias, isLoadingCompanias] = useFetcher(fetchCompanias, undefined, "fetchCompanias");
  const [empresaValue, setEmpresaValue] = useState(null);
  const [anticipoValue, setAnticipoValue] = useState(null);
  const [confidencialParaClienteValue, setConfidencialParaClienteValue] = useState(null);
  const [fechaRealDeIngresoValue, setFechaRealDeIngresoValue] = useState(null);
  const [servicioOfrecidoIdValue, setServicioOfrecidoIdValue] = useState(null);
  const [saveingOV, setSaveingOV] = useState(false);
  const [proveedorValue, setProveedoredorValue] = useState(null);
  const [proveedoresDefault, isLoadingProveedoresDefault] = useFetcher(getProveedoresMedicalStudies, [{ vendor: "alf" }]);
  const [isRQandCostosRequired, setIsRQandCostosRequired] = useState(false);
  const [subServicioOfrecidoIdValue, setSubservicioOfrecidoIdValue] = useState(null);
  const [needHaveACandidate, setNeedHaveACandidate] = useState(false);
  const [costoTotalDeServicioPorCantidadValue, setCostoTotalDeServicioPorCantidadValue] = useState(null);
  const [precioDelServicioValue, setPrecioDelServicioValue] = useState(null);

  // FILES-----------------------------------------------------------------------
  // OCULTA EL CAMPO PARA CARGAR ARCHIVOS EN ORDEN DE COMPRA
  const mostrarOrdenDeCompra = false;
  const [canAddFile, setCanAddFile] = useState(false);
  const [filesSoporteCliente, setFilesSoporteCliente] = useState(null);
  const [fileNameSoporteCliente, setFileNameSoporteCliente] = useState("Seleccione un archivo");
  const [filesOrdenDeCompra, setFilesOrdenDeCompra] = useState([]);
  const [fileNameOrdenDeCompra, setFileNameOrdenDeCompra] = useState("Seleccione un archivo");
  const [filesOrdenDeCompraToUpload, setFilesOrdenDeCompraToUpload] = useState(null);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [deletingFileId, setDeletingFileId] = useState(null);
  const [downloadingFileId, setDownloadingFileId] = useState(null);
  // FILES-----------------------------------------------------------------------

  // MAILS-----------------------------------------------------------------------
  const [emailList, setEmailList] = useState([]);

  const handleRemoveEmail = (index) => {
    const updatedList = emailList.filter((_, i) => i !== index);
    setEmailList(updatedList);
  };

  const emailString = emailList.join(";");
  // MAILS-----------------------------------------------------------------------

  useEffect(() => {
    if (notaFetched) {
      setNota(notaFetched && notaFetched.rows && notaFetched.rows[0]);
    }
  }, [notaFetched]);

  useEffect(() => {
    if (servicioOfrecidoIdValue) {
      setIsRQandCostosRequired(isFieldRequired(servicioOfrecidoIdValue, proveedorValue));
    }
  }, [servicioOfrecidoIdValue, proveedorValue]);

  const loadOptions = useDebouncedCallback((inputValue, callback) => {
    promiseOptions(inputValue).then(callback);
  }, 500);
  const proveedoresDefaultOptions =
    proveedoresDefault && proveedoresDefault.proveedoresNP ? proveedoresDefault.proveedoresNP.map((proveedor) => ({ label: proveedor.vendor, value: proveedor.id })) : [];

  const checkHasCandidates = async (id) => {
    const { result } = await getCandidatosByNP(id);
    if (result && result.length > 0) {
      return true;
    }
    toast.warning("La nota de pedido debe tener al menos un candidato para crear una orden de venta");
    setNeedHaveACandidate(true);
    return false;
  };

  useEffect(() => {
    if (nota) {
      checkHasCandidates(nota && nota.id);
    }
    if (nota && nota.servicioOfrecidoId) {
      setServicioOfrecidoIdValue(nota.servicioOfrecidoId);
    }
    if (nota && nota.servicioSubservicioId) {
      setSubservicioOfrecidoIdValue(nota.servicioSubservicioId);
    }

    // avisa si no hay responsable asignado
    if (!readOnly && nota && !nota.recruiter) {
      toast.warning("Antes de crear la orden de venta debe asignar un responsable");
    }
  }, [nota]);

  const booleanOptions = [
    { label: "Si", value: true },
    { label: "No", value: false },
  ];
  function getFunctionToFilter(filter, selected) {
    if (filter === "empresa") {
      setEmpresaValue(selected);
    }

    if (filter === "proveedorId") {
      setProveedoredorValue(selected);
    }

    if (filter === "anticipo") {
      setAnticipoValue(selected);
    }

    if (filter === "confidencialParaCliente") {
      setConfidencialParaClienteValue(selected);
    }
  }

  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const razonSocialAdeccoOptions =
    companias && companias.length > 0
      ? companias
          .map((e) => {
            // PARCHE Cambia id 3 por 4 para adaptar a datos en PIN Servivios
            const id = e.id === 3 ? 4 : e.id;
            return { label: `${e.text}`, value: id };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const handleDatesChange = (values, type) => {
    const fechaFormateada = moment(values).format("YYYY-MM-DD");

    if (type === "fechaRealDeIngreso") {
      if (values) {
        setFechaRealDeIngresoValue(fechaFormateada);
      } else {
        setFechaRealDeIngresoValue(null);
      }
    }
  };

  const handleFileChange = (e, type) => {
    const selectedFiles = e.target.files;
    if (type === "soporteCliente") {
      setFileNameSoporteCliente(selectedFiles[0].name);
      setFilesSoporteCliente(selectedFiles);
    }

    if (type === "ordenDeCompra") {
      setFileNameOrdenDeCompra(selectedFiles[0].name);
      setFilesOrdenDeCompraToUpload(orden && orden.idOrdenDeVenta ? selectedFiles : selectedFiles[0]);
      setCanAddFile(true);
    }
  };

  useEffect(() => {
    if (orden && orden.Files && orden.Files.length > 0 && orden.fileId) {
      setFileNameSoporteCliente(orden.Files.find((file) => file.id === orden.fileId).originalname);
      setFilesSoporteCliente(orden.Files.find((file) => file.id === orden.fileId));
      setFilesOrdenDeCompra(orden.Files.filter((file) => file.id !== orden.fileId));
    }
  }, [orden, nota]);

  const handleAddFileOrdenDeCompra = async () => {
    setUploadingFile(true);
    try {
      if (orden && orden.idOrdenDeVenta) {
        const { message, result } = await uploadFiles({ entity: "npOrdenDeVenta", entityId: orden.idOrdenDeVenta, files: filesOrdenDeCompraToUpload });
        toast.success(message);
        setFileNameOrdenDeCompra("Seleccione un archivo");
        setFilesOrdenDeCompra([...filesOrdenDeCompra, result[0]]);
      } else {
        setFileNameOrdenDeCompra("Seleccione un archivo");
        setFilesOrdenDeCompra([...filesOrdenDeCompra, filesOrdenDeCompraToUpload]);
      }
    } catch (error) {
      handleErrors(error, toast.error);
    } finally {
      setUploadingFile(false);
      setCanAddFile(false);
    }
  };

  const handleDeleteFileOrdenDeCompra = async (fileId, index) => {
    setDeletingFileId(fileId);
    try {
      if (orden && orden.idOrdenDeVenta) {
        // Si hay orden, eliminar por fileId
        const { message } = await removeFile({ entity: "npOrdenDeVenta", entityId: orden.idOrdenDeVenta, fileId });
        toast.success(message);
        const newFiles = filesOrdenDeCompra.filter((file) => file.id !== fileId);
        setFilesOrdenDeCompra(newFiles);
      } else {
        // Si no hay orden, eliminar por index
        const newFiles = filesOrdenDeCompra.filter((_, fileIndex) => fileIndex !== index);
        setFilesOrdenDeCompra(newFiles);
      }
    } catch (error) {
      handleErrors(error, toast.error);
    } finally {
      setDeletingFileId(null);
    }
  };

  const handleDownloadFileOrdenDeCompra = async (fileId) => {
    setDownloadingFileId(fileId);
    try {
      const { message } = await downloadFile({ entity: "npOrdenDeVenta", entityId: orden.idOrdenDeVenta, fileId });
      toast.success(message);
    } catch (error) {
      handleErrors(error, toast.error);
    } finally {
      setDownloadingFileId(null);
    }
  };

  const handlePOSTorPATCH = async () => {
    setSaveingOV(true);
    try {
      const { message, result } = await createOrUpdateOrdenDeVenta(data, ordenId);
      if (filesSoporteCliente && filesSoporteCliente.length > 0) {
        try {
          const res = await uploadOrPatchFileSoporteCliente(result.idOrdenDeVenta, filesSoporteCliente, orden && orden.fileId);
          let fileId;
          if (Array.isArray(res.result)) {
            fileId = res.result[0].id;
          } else {
            fileId = res.result.id;
          }
          // Actualiza la orden de venta con el fileId correcto
          await updateOrdenDeVenta(result.idOrdenDeVenta, { fileId });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }
      if (filesOrdenDeCompra && filesOrdenDeCompra.length > 0 && !orden) {
        try {
          await uploadFiles({ entity: "npOrdenDeVenta", entityId: result.idOrdenDeVenta, files: filesOrdenDeCompra });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
          toast.error(`Error subiendo los archivos de orden de compra. Intente nuevamente despues de crear la orden de venta.`);
        }
      }

      toast.success(message);
      toggleTab("2");
    } catch (error) {
      handleErrors(error, toast.error);
    }

    setSaveingOV(false);
  };

  const inputError = () => {
    const error = { error: false };

    if (empresaValue === null) {
      error.empresa = "Debe seleccionar una empresa.";
      error.error = true;
    } else if ((empresaValue && empresaValue.value === "") || (empresaValue && empresaValue.value === undefined)) {
      error.empresa = "Debe seleccionar una empresa.";
      error.error = true;
    }

    if (confidencialParaClienteValue === null) {
      error.confidencialParaCliente = "Debe seleccionar una opción.";
      error.error = true;
    } else if (
      (confidencialParaClienteValue && confidencialParaClienteValue.value === "") ||
      (confidencialParaClienteValue && confidencialParaClienteValue.value === undefined)
    ) {
      error.confidencialParaCliente = "Debe seleccionar una opción.";
      error.error = true;
    }

    if (proveedorValue === null && [4, 6, 8].includes(servicioOfrecidoIdValue)) {
      error.proveedorId = "Debe seleccionar un proveedor.";
      error.error = true;
    } else if (
      (proveedorValue && proveedorValue.value === "" && [4, 6, 8].includes(servicioOfrecidoIdValue)) ||
      (proveedorValue && proveedorValue.value === undefined && [4, 6, 8].includes(servicioOfrecidoIdValue))
    ) {
      error.proveedorId = "Debe seleccionar un proveedor.";
      error.error = true;
    }

    if (anticipoValue === null && !servicioOfrecidoIdValue && subServicioOfrecidoIdValue === 9) {
      error.anticipo = "Debe seleccionar una opción.";
      error.error = true;
    } else if (
      (anticipoValue && anticipoValue.value === "" && !servicioOfrecidoIdValue && subServicioOfrecidoIdValue === 9) ||
      (anticipoValue && anticipoValue.value === undefined && !servicioOfrecidoIdValue && subServicioOfrecidoIdValue === 9)
    ) {
      error.anticipo = "Debe seleccionar una opción.";
      error.error = true;
    }

    // muestra el error si no hay servicioOfrecidoIdValue y si anticipo es diferente de No
    if (
      fechaRealDeIngresoValue === null &&
      !servicioOfrecidoIdValue &&
      subServicioOfrecidoIdValue === 9 &&
      (!anticipoValue || (anticipoValue && anticipoValue.label === "No"))
    ) {
      error.fechaRealDeIngreso = "Debe seleccionar una fecha.";
      error.error = true;
    } else if (
      (fechaRealDeIngresoValue &&
        fechaRealDeIngresoValue === "" &&
        subServicioOfrecidoIdValue === 9 &&
        (!anticipoValue || (anticipoValue && anticipoValue.label === "No"))) ||
      (fechaRealDeIngresoValue &&
        fechaRealDeIngresoValue === undefined &&
        !servicioOfrecidoIdValue &&
        subServicioOfrecidoIdValue === 9 &&
        (!anticipoValue || (anticipoValue && anticipoValue.label === "No")))
    ) {
      error.fechaRealDeIngreso = "Debe seleccionar una fecha.";
      error.error = true;
    }

    if (costoTotalDeServicioPorCantidadValue === null && isRQandCostosRequired) {
      error.costoTotalDeServicioPorCantidad = "Este campo es obligatorio";
      error.error = true;
    } else if (
      (costoTotalDeServicioPorCantidadValue && costoTotalDeServicioPorCantidadValue === "" && isRQandCostosRequired) ||
      (costoTotalDeServicioPorCantidadValue && costoTotalDeServicioPorCantidadValue === undefined && isRQandCostosRequired)
    ) {
      error.costoTotalDeServicioPorCantidad = "Este campo es obligatorio";
      error.error = true;
    }

    if (precioDelServicioValue === null) {
      error.precioDelServicio = "Este campo es obligatorio";
      error.error = true;
    } else if ((precioDelServicioValue && precioDelServicioValue === "") || (precioDelServicioValue && precioDelServicioValue === undefined)) {
      error.precioDelServicio = "Este campo es obligatorio";
      error.error = true;
    }

    return error;
  };

  const messageError = inputError();

  const formik = useFormik({
    initialValues: {
      notaDePedidoId: null,
      estado: null,
      fechaCreacion: null,

      // PRIMERA SECCION
      empresa: null,
      cliente: null,
      subcliente: null,
      subclienteId: null,
      nroCotizacion: "",
      sucursalId: null,
      servicio: null,
      fechaRealDeIngreso: null,
      sueldoBruto: "",
      coeficiente: "",

      // SEGUNDA SECCION
      cantidad: "",
      precioDelServicio: "",
      bonificacion: 0,
      total: null,
      anticipo: true,
      nroOCAsociada: "",

      // TERCERA SECCION
      confidencialParaCliente: false,
      costoTotalDeServicioPorCantidad: "",
      rq: "",
      emailParaEnviarLaFactura: "",
      email: "",

      // CUARTA SECCION
      proveedorId: null,
      observacionesParaCliente: "",
      observacionesParaFacturador: "",

      responsable: null,
      creador: null,
      infoCotizacion: "",
      formaDePago: "",
      idPedido: "",
      fechaDeFactura: null,
      fechaEnvioFacturacion: null,
      fechaPedido: null,
      nroReferencia: "",
      fileId: null,
      cuit: "",
      cargo: "",
    },

    onSubmit: async (values) => {
      if (!emailList.length) {
        formik.setFieldError("email", "Es obligatorio añadir al menos un correo electrónico");
        formik.setFieldTouched("email", true);
        toast.error("Debe añadir al menos un email de facturación");
        return;
      }

      if (messageError.error) return;
      if (!values.subcliente) {
        formik.setFieldError("subcliente", "este campo es obligatorio");
        toast.error("Debe tener un subcliente");
        return;
      }
      if (fileNameSoporteCliente === "Seleccione un archivo") {
        toast.error("Debe subir un archivo en constancia de cliente");
        return;
      }
      if (!values.responsable) {
        toast.error("Debe asignar un responsable");
        return;
      }
      if (needHaveACandidate) {
        toast.warning("Debe crear al menos un candidato antes de crear una orden de venta");
        return;
      }

      if (!empresaValue && !empresaValue.value) {
        toast.error("No se puede guardar la orden de venta sin una empresa");
        return;
      }

      const dataToCreate = {
        ...values,
        bonificacion: 0,
        empresa: (empresaValue && empresaValue.value) || null,
        fechaRealDeIngreso: fechaRealDeIngresoValue || null,
        anticipo: anticipoValue !== undefined ? anticipoValue && anticipoValue.value : null,
        confidencialParaCliente: confidencialParaClienteValue !== undefined ? confidencialParaClienteValue && confidencialParaClienteValue.value : null,
        proveedorId: (proveedorValue && proveedorValue.value) || null,
        total: calcularTotal(values.cantidad, precioDelServicioValue && precioDelServicioValue.number, values.bonificacion).number || null,
        costoTotalDeServicioPorCantidad: (costoTotalDeServicioPorCantidadValue && costoTotalDeServicioPorCantidadValue.number) || null,
        precioDelServicio: (precioDelServicioValue && precioDelServicioValue.number) || null,
        rq: values.rq === "" ? null : values.rq,
        emailParaEnviarLaFactura: emailString || "",
      };

      setData(dataToCreate);
      setShowConfirmModal(true);
    },
    validationSchema: Yup.object().shape({
      cantidad: Yup.number().required("Este campo es requerido."),
      bonificacion: Yup.number()
        .required("Este campo es requerido.")
        .test("is-decimal", "Solo se permiten hasta 2 decimales.", (value) => value !== undefined && /^\d+(\.\d{1,2})?$/.test(value.toString())),
      coeficiente: Yup.number()
        .required("Este campo es requerido.")
        .test("is-decimal", "Solo se permiten hasta 2 decimales.", (value) => value !== undefined && /^\d+(\.\d{1,2})?$/.test(value.toString())),
      sueldoBruto: Yup.number()
        .required("Este campo es requerido.")
        .test("is-decimal", "Solo se permiten hasta 2 decimales.", (value) => value !== undefined && /^\d+(\.\d{1,2})?$/.test(value.toString())),
      rq: isRQandCostosRequired
        ? Yup.string()
            .required("Este campo es requerido.")
            .matches(/^\d{6}$/, "Debe contener exactamente 6 caracteres numéricos.")
        : null,
    }),
  });

  useEffect(async () => {
    if (orden) {
      const {
        idOrdenDeVenta,
        anticipo,
        confidencialParaCliente,
        proveedor,
        precioDelServicio,
        costoTotalDeServicioPorCantidad,
        emailParaEnviarLaFactura,
        fechaRealDeIngreso,
        empresa,
        cuit,
        cargo,
        coeficiente,
        sueldoBruto,
        ...restoDeLaOrden
      } = orden;

      setAnticipoValue(booleanOptions.find((e) => e.value === anticipo));
      setConfidencialParaClienteValue(booleanOptions.find((e) => e.value === confidencialParaCliente));
      setProveedoredorValue(proveedor ? { label: proveedor.vendor, value: proveedor.id } : null);
      setEmpresaValue(razonSocialAdeccoOptions.find((e) => e.value === empresa));
      setPrecioDelServicioValue(precioDelServicio ? { number: precioDelServicio, value: formatNumberWithCommas(precioDelServicio) } : null);
      setCostoTotalDeServicioPorCantidadValue(
        costoTotalDeServicioPorCantidad ? { number: costoTotalDeServicioPorCantidad, value: formatNumberWithCommas(costoTotalDeServicioPorCantidad) } : null
      );
      setEmailList(emailParaEnviarLaFactura ? emailParaEnviarLaFactura.split(";") : []);
      setFechaRealDeIngresoValue(fechaRealDeIngreso || null);
      formik.setValues({
        ...restoDeLaOrden,
        bonificacion: 0,
        formaDePago: (nota && nota.formaDePago) || " ",
        coeficiente: coeficiente ? JSON.stringify(coeficiente) : "",
        sueldoBruto: sueldoBruto ? JSON.stringify(sueldoBruto) : "",
      });
    } else if (nota) {
      formik.setValues({
        ...formik.values,
        bonificacion: 0,
        notaDePedidoId: nota.id,
        estado: 1,
        fechaCreacion: fechaActual,

        subclienteId: nota.subClienteId,
        cliente: nota.razonSocial,
        subcliente: (nota && nota.subClienteLegajo) || null,
        nroCotizacion: (nota.cotizacionNP && nota.cotizacionNP.idCotizacion) || " ",
        formaDePago: (nota && nota.formaDePago) || " ",
        sucursalId: nota.sucursalId,
        servicio: (nota.servicioOfrecido && nota.servicioOfrecido.nombre) || (nota.servicioSubservicio && nota.servicioSubservicio.subservicio),
        sueldoBruto: (nota && nota.salarioBruto) || "",
        coeficiente: nota.cotizacionNP && nota.cotizacionNP.coeficiente ? JSON.stringify(nota.cotizacionNP.coeficiente) : "",

        cantidad: (nota && nota.vacantes) || "",

        creador: nota.responsableAE,
        infoCotizacion: nota.cotizacionNP && nota.cotizacionNP.descripcion,
        idPedido: nota.idPedido,
        cuit: nota.cuit,
        cargo: nota.cargo,
      });

      setEmpresaValue(razonSocialAdeccoOptions.find((e) => e.value === nota.empresaAdecco));

      // valores que deben actualizarse con la NP
      if (!readOnly) {
        formik.setFieldValue("responsable", (nota && nota.recruiter) || null);
      }
    }
  }, [nota, sucursales, companias]);

  const handleAddEmail = (e) => {
    e.preventDefault();
    const email = formik.values.email.trim();

    if (email && !emailList.includes(email)) {
      if (validateEmail(email)) {
        setEmailList([...emailList, email]);
        formik.setFieldValue("email", "");
        formik.setFieldError("email", "");
      } else {
        formik.setFieldError("email", "Debe ingresar un correo electrónico válido");
      }
    }
  };

  return (
    <>
      <BlurSpinner isLoading={formik.isSubmitting || isLoadingSucursales || !nota || isLoadingPis || isLoadingCompanias || isLoadingNota || !nota}>
        <Container>
          <form className="theme-form" onSubmit={formik.handleSubmit}>
            <div style={{ fontFamily: "Nunito" }}>
              <div className="d-flex flex-column justify-content-between align-items-start">
                {/* PRIMERA SECCION */}
                <div className="w-100 mb-3">
                  <div>
                    <GridGroup3>
                      <div className="mb-1">
                        <CustomLabel>Razon social Adecco*</CustomLabel>
                        <LabSelect
                          name="empresa"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={empresaValue}
                          placeholder="seleccionar"
                          isClearable
                          isLoading={isLoadingCompanias}
                          isDisabled
                          options={razonSocialAdeccoOptions ? razonSocialAdeccoOptions.filter((e) => e.value !== 1) : []}
                          style={messageError.empresa && formik.touched.empresa ? { borderBottom: "1px solid red" } : null}
                        />
                        {messageError.empresa && formik.touched.empresa && (
                          <CustomLabel style={{ color: "red" }} className="input-feedback">
                            {messageError.empresa}
                          </CustomLabel>
                        )}
                      </div>

                      <div className="mb-1">
                        <CustomLabel>Razon social cliente*</CustomLabel>
                        <InputText type="text" id="cliente" disabled value={formik.values.cliente || "sin cliente"} />
                      </div>
                      <div className="mb-1">
                        <CustomLabel>Subcliente*</CustomLabel>
                        <InputText type="text" id="subcliente" disabled value={formik.values.subcliente || "sin subcliente"} />
                      </div>
                      <div className="mb-1">
                        <CustomLabel>Número de cotizacion</CustomLabel>
                        <InputText type="text" id="nroCotizacion" disabled value={formik.values.nroCotizacion || "sin cotizacion"} />
                      </div>
                      <div className="mb-1">
                        <CustomLabel>Info de cotizacion</CustomLabel>
                        <InputText type="text" id="nroCotizacion" disabled value={formik.values.formaDePago || "sin info"} />
                      </div>
                      <div className="mb-1">
                        <CustomLabel>Sucursal*</CustomLabel>
                        <InputText
                          type="text"
                          id="sucursalId"
                          disabled
                          value={formik.values.sucursalId ? getSucursalTitleById(formik.values.sucursalId, sucursales) : "sin sucursal"}
                        />
                      </div>

                      <div className="mb-1">
                        <CustomLabel>Servicio*</CustomLabel>
                        <InputText type="text" id="servicio" disabled value={formik.values.servicio || "sin servicio"} maxLength={40} />
                      </div>

                      <div className="mb-1">
                        <CustomLabel>Responsable*</CustomLabel>
                        <InputText
                          type="text"
                          id="responsable"
                          disabled
                          value={formik.values.responsable ? getPiById(formik.values.responsable, pis) : "sin responsable"}
                          maxLength={40}
                        />
                      </div>

                      <div>
                        <StylesDatePicker className="mb-1">
                          <CustomLabel htmlFor="fechaRealDeIngreso"> Fecha real de ingreso </CustomLabel>
                          <DatePicker
                            locale={locale}
                            showIcon
                            className="digits date-input"
                            dateFormat="DD-MM-AAAA"
                            disabled={formik.isSubmitting || readOnly}
                            onChange={(e) => handleDatesChange(e, "fechaRealDeIngreso")}
                            value={fechaRealDeIngresoValue ? formatearFecha(fechaRealDeIngresoValue) : null}
                            placeholderText="ingrese fecha"
                            isClearable={!readOnly}
                            clearButtonClassName="clear-button"
                            selected={fechaRealDeIngresoValue ? new Date(fechaRealDeIngresoValue).setDate(new Date(fechaRealDeIngresoValue).getDate() + 1) : null}
                          />
                        </StylesDatePicker>
                        {messageError.fechaRealDeIngreso && formik.touched.fechaRealDeIngreso && (
                          <CustomLabel style={{ color: "red" }} className="input-feedback">
                            {messageError.fechaRealDeIngreso}
                          </CustomLabel>
                        )}
                      </div>

                      <div className="mb-1">
                        <CustomLabel>Sueldo Bruto</CustomLabel>
                        <InputText
                          type="text"
                          id="sueldoBruto"
                          //   disabled
                          onChange={(e) => {
                            const { value } = e.target;
                            if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                              formik.setFieldValue("sueldoBruto", value);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.sueldoBruto}
                          maxLength={40}
                          disabled={readOnly}
                          style={formik.errors.sueldoBruto && formik.touched.sueldoBruto ? { borderBottom: "1px solid red", placeholder: "red" } : null}
                        />
                        {formik.errors.sueldoBruto && formik.touched.sueldoBruto && (
                          <CustomLabel style={{ color: "red" }} className="input-feedback">
                            {formik.errors.sueldoBruto}
                          </CustomLabel>
                        )}
                      </div>
                      <div className="mb-1">
                        <CustomLabel>Coeficiente</CustomLabel>
                        <InputText
                          type="text"
                          id="coeficiente"
                          //   disabled
                          onChange={(e) => {
                            const { value } = e.target;
                            if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                              formik.setFieldValue("coeficiente", value);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.coeficiente}
                          maxLength={40}
                          disabled={readOnly}
                          style={formik.errors.coeficiente && formik.touched.coeficiente ? { borderBottom: "1px solid red", placeholder: "red" } : null}
                        />
                        {formik.errors.coeficiente && formik.touched.coeficiente && (
                          <CustomLabel style={{ color: "red" }} className="input-feedback">
                            {formik.errors.coeficiente}
                          </CustomLabel>
                        )}
                      </div>
                    </GridGroup3>
                  </div>
                </div>

                {/* SEGUNDA SECCION */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1 ">
                    <TemplateHeader />
                  </div>
                  <div>
                    <GridGroup3>
                      <div className="mb-1">
                        <CustomLabel htmlFor="cantidad">Cantidad*</CustomLabel>
                        <InputText
                          type="number"
                          id="cantidad"
                          disabled={formik.onSubmit || readOnly}
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={formik.values.cantidad}
                          style={formik.errors.cantidad && formik.touched.cantidad ? { borderBottom: "1px solid red", placeholder: "red" } : null}
                          onWheel={(e) => e.target.blur()}
                        />
                        {formik.errors.cantidad && formik.touched.cantidad && <CustomLabel style={{ color: "red" }}>{formik.errors.cantidad}</CustomLabel>}
                      </div>

                      <div className="mb-1">
                        <CustomLabel>Precio del servicio*</CustomLabel>
                        <InputNumberFormatWrapper>
                          <InputNumberFormat
                            // locales="en"
                            locales={["ban", "id"]}
                            id="precioDelServicio"
                            onNumberFormat={(event) => setPrecioDelServicioValue(event && event.detail && event.detail)}
                            disabled={formik.onSubmit || readOnly}
                            onBlur={formik.handleBlur}
                            value={(precioDelServicioValue && precioDelServicioValue.value) || ""}
                            thousandSeparator="."
                            decimalSeparator=","
                            style={messageError.precioDelServicio && formik.touched.precioDelServicio ? { borderBottom: "1px solid red", placeholder: "red" } : null}
                          />
                        </InputNumberFormatWrapper>
                        {messageError.precioDelServicio && formik.touched.precioDelServicio && (
                          <CustomLabel style={{ color: "red" }}>{messageError.precioDelServicio}</CustomLabel>
                        )}
                      </div>

                      {/* <div className="mb-1">
                        <CustomLabel>Importe bonificación</CustomLabel>
                        <InputText
                          type="text"
                          id="bonificacion"
                          disabled
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.bonificacion}
                          maxLength={40}
                          style={formik.errors.bonificacion && formik.touched.bonificacion ? { borderBottom: "1px solid red", placeholder: "red" } : null}
                          step="0.01"
                          onWheel={(e) => e.target.blur()}
                        />
                        {formik.errors.bonificacion && formik.touched.bonificacion && <CustomLabel style={{ color: "red" }}>{formik.errors.bonificacion}</CustomLabel>}
                      </div> */}

                      <div className="mb-1">
                        <CustomLabel>Total</CustomLabel>
                        <InputText
                          id="total"
                          name="total"
                          disabled
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={calcularTotal(formik.values.cantidad, precioDelServicioValue && precioDelServicioValue.number, formik.values.bonificacion).value}
                          maxLength={40}
                          style={formik.errors.total && formik.touched.total ? { borderBottom: "1px solid red", placeholder: "red" } : null}
                        />
                      </div>

                      {/* solo se muestra en busqueda y seleccion */}
                      {!servicioOfrecidoIdValue && subServicioOfrecidoIdValue === 9 && (
                        <div className="mb-1">
                          <CustomLabel>Anticipo*</CustomLabel>
                          <LabSelect
                            id="anticipo"
                            name="anticipo"
                            className="w-100"
                            onChange={handleReactSelectChange}
                            value={anticipoValue}
                            placeholder="seleccionar"
                            isClearable
                            isDisabled={formik.isSubmitting || readOnly}
                            options={booleanOptions}
                          />
                          {messageError.anticipo && formik.touched.anticipo && (
                            <CustomLabel style={{ color: "red" }} className="input-feedback">
                              {messageError.anticipo}
                            </CustomLabel>
                          )}
                        </div>
                      )}

                      <div className="mb-1">
                        <CustomLabel>Nro OC asociada</CustomLabel>
                        <InputText
                          type="text"
                          id="nroOCAsociada"
                          //   disabled
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.nroOCAsociada}
                          maxLength={40}
                          disabled={readOnly}
                        />
                      </div>
                    </GridGroup3>
                  </div>
                </div>

                {/* TERCERA SECCION */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader />
                  </div>
                  <GridGroup3>
                    <div className="mb-3">
                      <CustomLabel htmlFor="confidencialParaCliente">¿Es confidencial para el cliente?*</CustomLabel>
                      <LabSelect
                        id="confidencialParaCliente"
                        name="confidencialParaCliente"
                        className="w-100"
                        onChange={handleReactSelectChange}
                        value={confidencialParaClienteValue}
                        placeholder="Seleccionar..."
                        isClearable
                        isDisabled={formik.isSubmitting || readOnly}
                        options={booleanOptions}
                      />
                      {messageError.confidencialParaCliente && formik.touched.confidencialParaCliente && (
                        <CustomLabel style={{ color: "red" }} className="input-feedback">
                          {messageError.confidencialParaCliente}
                        </CustomLabel>
                      )}
                    </div>
                  </GridGroup3>
                  <GridGroup3>
                    {[4, 6, 8].includes(servicioOfrecidoIdValue) && (
                      <>
                        <div className="mb-1">
                          <CustomLabel htmlFor="costoTotalDeServicioPorCantidad"> Costos (Cargar costo total por cant. total del servicio) </CustomLabel>
                          <InputNumberFormatWrapper>
                            <InputNumberFormat
                              // locales="en"
                              locales={["ban", "id"]}
                              id="costoTotalDeServicioPorCantidad"
                              name="costoTotalDeServicioPorCantidad"
                              disabled={formik.isSubmitting || readOnly}
                              onNumberFormat={(event) => setCostoTotalDeServicioPorCantidadValue(event && event.detail)}
                              defaultValue={(costoTotalDeServicioPorCantidadValue && costoTotalDeServicioPorCantidadValue.value) || null}
                              onBlur={formik.handleBlur}
                              style={
                                messageError.costoTotalDeServicioPorCantidad && formik.touched.costoTotalDeServicioPorCantidad
                                  ? { borderBottom: "1px solid red", placeholder: "red" }
                                  : null
                              }
                            />
                          </InputNumberFormatWrapper>
                          {messageError.costoTotalDeServicioPorCantidad && formik.touched.costoTotalDeServicioPorCantidad && (
                            <CustomLabel style={{ color: "red" }}>{messageError.costoTotalDeServicioPorCantidad}</CustomLabel>
                          )}
                        </div>
                        <div className="mb-3">
                          <CustomLabel htmlFor="rq"> RQ* </CustomLabel>
                          <InputText
                            type="number"
                            id="rq"
                            disabled={formik.isSubmitting || readOnly}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.rq}
                            maxLength={40}
                            onWheel={(e) => e.target.blur()}
                            step="0.01"
                            style={formik.errors.rq && formik.touched.rq ? { borderBottom: "1px solid red", placeholder: "red" } : null}
                          />
                          {formik.errors.rq && formik.touched.rq && <CustomLabel style={{ color: "red" }}>{formik.errors.rq}</CustomLabel>}
                        </div>
                      </>
                    )}
                  </GridGroup3>
                  <div>
                    <div className="mb-3">
                      <CustomLabel htmlFor="emailParaEnviarLaFactura">Emails para enviar la Factura*</CustomLabel>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <InputText
                          type="email"
                          id="email"
                          disabled={formik.isSubmitting || readOnly}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.email}
                          maxLength={60}
                          style={formik.errors.email && formik.touched.email ? { borderBottom: "1px solid red" } : null}
                        />
                        {formik.errors.email && formik.touched.email && <CustomLabel style={{ color: "red" }}>{formik.errors.email}</CustomLabel>}
                        <ButtonPrimary type="button" onClick={handleAddEmail} disabled={!formik.values.email || formik.errors.email} style={{ marginLeft: "10px" }}>
                          Agregar
                        </ButtonPrimary>
                      </div>
                    </div>

                    {/* Lista de emails */}
                    <div className="mb-3 w-50" style={{ listStyle: "none", paddingLeft: 0 }}>
                      {emailList.map((email, index) => (
                        <div className="m-0 w-100" key={email}>
                          <div className="d-flex align-items-center justify-content-between border-bottom w-100">
                            <p className="mr-2 mb-1">{email}</p>
                            <div className="d-flex align-items-center">
                              <Trash2 size="14" color="#293134" style={{ cursor: "pointer" }} onClick={() => handleRemoveEmail(index)} />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <input type="hidden" name="emailString" value={emailString} />
                  </div>
                </div>

                {/* CUARTA SECCION */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader />
                  </div>
                  {[4, 6, 8].includes(servicioOfrecidoIdValue) && (
                    <div>
                      <CustomLabel htmlFor="proveedorId" className="mb-3 pt-0 w-50">
                        Proveedor*
                        <AsyncLabSelect
                          id="proveedorId"
                          name="proveedorId"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={proveedorValue}
                          placeholder="Seleccionar..."
                          isClearable
                          loadOptions={loadOptions}
                          defaultOptions={proveedoresDefaultOptions}
                          isLoading={isLoadingProveedoresDefault}
                          isDisabled={formik.isSubmitting || readOnly}
                        />
                        {messageError.proveedorId && formik.touched.proveedorId && (
                          <CustomLabel style={{ color: "red" }} className="input-feedback">
                            {messageError.proveedorId}
                          </CustomLabel>
                        )}
                      </CustomLabel>
                    </div>
                  )}

                  <div className="mb-1">
                    <CustomLabel htmlFor="observacionesParaCliente"> Observaciones para el cliente</CustomLabel>
                    <InputTextArea
                      type="text"
                      id="observacionesParaCliente"
                      name="observacionesParaCliente"
                      disabled={formik.isSubmitting || readOnly || (confidencialParaClienteValue && confidencialParaClienteValue.value === true)}
                      onChange={(e) => {
                        if (confidencialParaClienteValue && confidencialParaClienteValue.value === true) {
                          formik.setFieldValue("observacionesParaCliente", null);
                        } else {
                          formik.handleChange(e);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={confidencialParaClienteValue && confidencialParaClienteValue.value === true ? "" : formik.values.observacionesParaCliente}
                      maxLength="100"
                    />
                  </div>
                  <div className="mb-1">
                    <CustomLabel htmlFor="observacionesParaFacturador"> Observaciones para el facturador</CustomLabel>
                    <InputTextArea
                      type="text"
                      id="observacionesParaFacturador"
                      name="observacionesParaFacturador"
                      disabled={formik.isSubmitting || readOnly}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.observacionesParaFacturador}
                      maxLength="100"
                    />
                  </div>
                  <div className="mb-3">
                    <CustomLabel htmlFor="soporteCliente"> Soporte cliente*</CustomLabel>
                    <div className="custom-file">
                      <InputText
                        className="custom-file-input"
                        type="file"
                        id="upfileSoporteCliente"
                        onChange={(e) => handleFileChange(e, "soporteCliente")}
                        accept=".pdf"
                        style={readOnly ? { cursor: "not-allowed" } : { cursor: "pointer", border: "none" }}
                        disabled={formik.isSubmitting || readOnly}
                      />
                      <InputFile className="custom-file-label" htmlFor="upfileSoporteCliente">
                        {fileNameSoporteCliente}
                      </InputFile>
                    </div>
                  </div>
                  {mostrarOrdenDeCompra && (
                    <div className="mb-3">
                      <CustomLabel htmlFor="ordenDeCompra"> Orden de compra</CustomLabel>
                      <div className="d-flex">
                        <div className="custom-file">
                          <InputText
                            className="custom-file-input"
                            type="file"
                            id="upfileOrdenDeCompra"
                            onChange={(e) => handleFileChange(e, "ordenDeCompra")}
                            accept=".pdf"
                            style={readOnly ? { cursor: "not-allowed" } : { cursor: "pointer", border: "none" }}
                            disabled={formik.isSubmitting || readOnly}
                          />
                          <InputFile className="custom-file-label" htmlFor="upfileOrdenDeCompra">
                            {fileNameOrdenDeCompra}
                          </InputFile>
                        </div>
                        <SpinnerButtonPrimary
                          isLoading={uploadingFile}
                          disabled={!canAddFile}
                          className="ml-2 mr-0"
                          size="sm"
                          type="button"
                          onClick={handleAddFileOrdenDeCompra}
                        >
                          Agregar
                        </SpinnerButtonPrimary>
                      </div>
                      <div>
                        {filesOrdenDeCompra && filesOrdenDeCompra.length > 0 && (
                          <div className="mt-2 border p-2">
                            <p className="text-muted">Archivos adjuntos</p>
                            <div className="d-flex flex-column align-items-start w-50">
                              {filesOrdenDeCompra.map((file, index) => (
                                <div className="m-0 w-100" key={file.id}>
                                  <div className="d-flex align-items-center justify-content-between border-bottom w-100">
                                    <p className="mr-2 mb-1">{orden && orden.idOrdenDeVenta ? file.originalname : file.name}</p>
                                    <div className="d-flex align-items-center">
                                      {deletingFileId === file.id ? (
                                        <Spinner />
                                      ) : (
                                        <Trash2 size="14" color="#293134" style={{ cursor: "pointer" }} onClick={() => handleDeleteFileOrdenDeCompra(file.id, index)} />
                                      )}
                                      {orden && orden.idOrdenDeVenta && (
                                        <>
                                          {downloadingFileId === file.id ? (
                                            <Spinner className="ml-2" />
                                          ) : (
                                            <Download
                                              size="14"
                                              color="#293134"
                                              disabled={!orden}
                                              style={{ cursor: "pointer", marginLeft: "10px" }}
                                              onClick={() => handleDownloadFileOrdenDeCompra(file.id)}
                                            />
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* QUINTA SECCION */}
                {orden && orden.estado > 2 ? (
                  <div className="w-100 mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <TemplateHeader />
                    </div>
                    <GridGroup3>
                      <div className="mb-1">
                        <CustomLabel htmlFor="facturador"> Facturador*</CustomLabel>
                        <InputText type="text" id="facturador" name="facturador" disabled value={formik.values.facturador} maxLength="100" />
                      </div>

                      <div className="mb-1">
                        <CustomLabel htmlFor="numeroFactura"> Nro de factura*</CustomLabel>
                        <InputText type="text" id="numeroFactura" name="numeroFactura" disabled value={formik.values.numeroFactura} maxLength={40} />
                      </div>

                      <div className="mb-1">
                        <CustomLabel htmlFor="centroFacturacion"> Centro de facturación*</CustomLabel>
                        <InputText type="text" id="centroFacturacion" name="centroFacturacion" disabled value={formik.values.centroFacturacion} maxLength={40} />
                      </div>

                      <div className="mb-1">
                        <CustomLabel htmlFor="numeroPedidoERP"> Nro de pedido ERP*</CustomLabel>
                        <InputText type="text" id="numeroPedidoERP" name="numeroPedidoERP" disabled value={formik.values.numeroPedidoERP} maxLength={40} />
                      </div>
                    </GridGroup3>

                    <div className="mb-1">
                      <CustomLabel htmlFor="notasDelUsuario"> Notas del usuario*</CustomLabel>
                      <InputTextArea type="text" id="notasDelUsuario" name="notasDelUsuario" disabled value={formik.values.observacionesParaFacturador} maxLength={100} />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="descripcionEstado"> Descripción de estado*</CustomLabel>
                      <InputTextArea type="text" id="descripcionEstado" name="descripcionEstado" disabled value={formik.values.descripcionEstado} maxLength={100} />
                    </div>
                  </div>
                ) : null}
                {/* ------- */}
              </div>
              <div className="d-flex justify-content-end">
                <Button className="mr-2" size="sm" color="btn" type="button" onClick={toggle}>
                  Cancelar
                </Button>
                <ButtonPrimary size="sm" className="btn" type="submit" disabled={formik.isSubmitting || readOnly}>
                  Guardar
                </ButtonPrimary>
              </div>
            </div>
          </form>
          {showConfirmModal && (
            <Modal size="sm" centered isOpen={showConfirmModal}>
              <ModalBody>
                <FontAwesomeIcon icon={faWarning} className="-100" color="red" size="3x" />
                <p
                  className="d-block badge-pills h-50 w-100 justify-content-center text-center py-2 mt-2"
                  style={{ fontSize: "14px", fontWeight: "normal", fontFamily: "Nunito" }}
                >
                  {orden ? "Se guardarán los cambios en esta orden de venta. ¿Deseas continuar?" : "Estás creando una nueva orden de venta. ¿Deseas continuar?"}
                </p>
              </ModalBody>
              <div className="d-flex justify-content-end m-3">
                <ModalButton className="btn px-2 py-1 text-center mr-2" onClick={() => setShowConfirmModal(false)} type="button">
                  Cancelar
                </ModalButton>
                <SpinnerButtonPrimary
                  isLoading={saveingOV}
                  fontSize="12px"
                  padding="5px 10px"
                  type="button"
                  disabled={formik.isSubmitting || readOnly}
                  onClick={handlePOSTorPATCH}
                >
                  Confirmar
                </SpinnerButtonPrimary>
              </div>
            </Modal>
          )}
        </Container>
      </BlurSpinner>
    </>
  );
}
